import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, AlertTriangle, Mail, Phone, MapPin } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const WebsiteDisclaimer = () => {
  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh' }}>
      <Header />
      <main style={{ paddingTop: '200px' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(135deg, rgba(0, 255, 209, 0.05) 0%, rgba(0, 0, 0, 0) 100%)',
          padding: '60px 7.6923%',
          borderBottom: '1px solid var(--border-subtle)'
        }}>
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <Link to="/" style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              color: 'var(--brand-primary)',
              textDecoration: 'none',
              marginBottom: '30px',
              fontSize: '14px'
            }}>
              <ArrowLeft size={16} />
              Back to Home
            </Link>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px' }}>
              <AlertTriangle size={40} color="var(--brand-primary)" />
              <h1 className="heading-1" style={{ margin: 0 }}>Website Disclaimer</h1>
            </div>
            
            <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
              VDM Business Innovations
            </p>
            <p className="body-medium" style={{ color: 'var(--text-muted)' }}>
              <strong>Effective Date:</strong> February 8, 2026 | <strong>Last Updated:</strong> February 8, 2026
            </p>
          </div>
        </section>

        {/* Content */}
        <section style={{ padding: '60px 7.6923%' }}>
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            
            {/* Section 1 */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>1. Introduction</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '16px' }}>
                This Website Disclaimer applies to the website https://vdmbi.org operated by VDM Business Innovations, a business development and consulting organization registered in India with headquarters in Bengaluru, Karnataka.
              </p>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '16px' }}>
                This Disclaimer sets forth the terms, conditions, and limitations regarding the use of information, content, and services provided through our Website.
              </p>
              <div style={{ 
                background: 'rgba(255, 107, 107, 0.1)', 
                border: '1px solid rgba(255, 107, 107, 0.3)', 
                padding: '16px' 
              }}>
                <p className="body-medium" style={{ color: '#FF6B6B', fontWeight: '600' }}>
                  IF YOU DO NOT AGREE WITH THIS DISCLAIMER, PLEASE DO NOT USE THIS WEBSITE.
                </p>
              </div>
            </div>

            {/* Section 2 */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>2. General Information Purpose</h2>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>2.1 Informational Content Only</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '16px' }}>
                The information provided on this Website is for general informational and educational purposes only. The content should not be construed as:
              </p>
              <ul style={{ color: 'var(--text-secondary)', lineHeight: '1.8', paddingLeft: '24px', marginBottom: '20px' }}>
                <li>Professional advice (legal, financial, tax, investment, or business)</li>
                <li>Binding offers, commitments, or guarantees of service</li>
                <li>Comprehensive or exhaustive treatment of any subject matter</li>
                <li>Personalized recommendations for specific situations</li>
                <li>Substitute for professional consultation or due diligence</li>
              </ul>

              <h3 className="heading-3" style={{ marginBottom: '12px' }}>2.2 No Professional Relationship</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                Accessing information on this Website does not create a professional, advisory, fiduciary, or client relationship between you and VDM Business Innovations. Professional relationships are established only through formal engagement agreements signed by authorized representatives.
              </p>
            </div>

            {/* Section 3 */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>3. No Warranties or Representations</h2>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>3.1 Accuracy and Completeness</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '16px' }}>
                While we strive to provide accurate information, VDM Business Innovations makes no representation or warranty regarding accuracy, completeness, reliability, timeliness, suitability, or availability of content.
              </p>

              <div style={{ 
                background: 'rgba(255, 107, 107, 0.05)', 
                border: '1px solid rgba(255, 107, 107, 0.3)', 
                padding: '20px', 
                marginBottom: '16px' 
              }}>
                <h4 style={{ color: '#FF6B6B', marginBottom: '12px' }}>3.2 "AS IS" Basis</h4>
                <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                  THIS WEBSITE AND ALL CONTENT, INFORMATION, SERVICES, AND MATERIALS ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
                </p>
              </div>
            </div>

            {/* Section 4 */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>4. Limitation of Liability</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '16px' }}>
                TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE INDIAN LAW, VDM BUSINESS INNOVATIONS SHALL NOT BE LIABLE FOR ANY:
              </p>
              <ul style={{ color: 'var(--text-secondary)', lineHeight: '1.8', paddingLeft: '24px', marginBottom: '20px' }}>
                <li>Direct, indirect, incidental, special, consequential, or punitive damages</li>
                <li>Loss of profits, revenue, business opportunities, or goodwill</li>
                <li>Loss of data, information, or business interruption</li>
                <li>Damages arising from reliance on information provided on this Website</li>
                <li>Damages caused by viruses, malware, or other harmful components</li>
              </ul>

              <h3 className="heading-3" style={{ marginBottom: '12px' }}>4.2 User Assumption of Risk</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                You expressly acknowledge that use of this Website is at your sole risk. You assume full responsibility for any decisions made based on Website information and will conduct independent verification and due diligence.
              </p>
            </div>

            {/* Section 5 */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>5. Business Services Disclaimers</h2>
              
              <div style={{ display: 'grid', gap: '20px' }}>
                <div style={{ background: 'rgba(255,255,255,0.03)', padding: '20px', border: '1px solid var(--border-subtle)' }}>
                  <h4 style={{ color: 'var(--text-primary)', marginBottom: '12px' }}>5.1 Real Estate Services (Zenthara)</h4>
                  <ul style={{ color: 'var(--text-secondary)', fontSize: '14px', paddingLeft: '18px', lineHeight: '1.8' }}>
                    <li>We do not guarantee availability of any specific property or retail space</li>
                    <li>Property information is subject to change without notice</li>
                    <li>Clients must conduct independent legal, financial, and technical due diligence</li>
                    <li>Third-party decisions are beyond our control</li>
                  </ul>
                </div>

                <div style={{ background: 'rgba(255,255,255,0.03)', padding: '20px', border: '1px solid var(--border-subtle)' }}>
                  <h4 style={{ color: 'var(--text-primary)', marginBottom: '12px' }}>5.2 Environmental Solutions (Nuvora)</h4>
                  <ul style={{ color: 'var(--text-secondary)', fontSize: '14px', paddingLeft: '18px', lineHeight: '1.8' }}>
                    <li>System performance depends on proper operation and maintenance</li>
                    <li>We do not guarantee specific environmental outcomes or certifications</li>
                    <li>Regulatory approvals are subject to government authority discretion</li>
                    <li>Client responsible for securing necessary environmental clearances</li>
                  </ul>
                </div>

                <div style={{ background: 'rgba(255,255,255,0.03)', padding: '20px', border: '1px solid var(--border-subtle)' }}>
                  <h4 style={{ color: 'var(--text-primary)', marginBottom: '12px' }}>5.3 Technology Applications</h4>
                  <ul style={{ color: 'var(--text-secondary)', fontSize: '14px', paddingLeft: '18px', lineHeight: '1.8' }}>
                    <li>AI-generated outputs are probabilistic and may contain errors</li>
                    <li>Technology tools supplement, not replace, human expertise</li>
                    <li>Users responsible for verifying accuracy of AI-generated information</li>
                    <li>We do not guarantee specific outcomes from use of applications</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Section 6 */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>6. Financial and Investment Disclaimers</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '16px' }}>
                Nothing on this Website constitutes financial, investment, tax, accounting, or legal advice. Before making any financial decisions, you should consult with qualified professionals and conduct comprehensive due diligence.
              </p>
              <div style={{ 
                background: 'rgba(255, 193, 7, 0.1)', 
                border: '1px solid rgba(255, 193, 7, 0.5)', 
                padding: '16px' 
              }}>
                <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                  <strong>Important:</strong> Past performance does not guarantee future results. Financial projections are forward-looking statements subject to uncertainties. Actual results may differ materially.
                </p>
              </div>
            </div>

            {/* Section 7 */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>7. External Links and Third-Party Content</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '16px' }}>
                This Website may contain links to third-party websites. We do not endorse, approve, or recommend third-party websites or services, and we are not responsible for third-party content, policies, or practices.
              </p>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                When accessing third-party links, you leave our Website and are subject to their terms and policies. You should review third-party privacy policies and terms of service.
              </p>
            </div>

            {/* Section 10 */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>10. Website Availability and Technical Issues</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '16px' }}>
                We do not warrant that the Website will be available continuously, free from errors, or that defects will be corrected promptly. The Website may be temporarily unavailable due to maintenance, updates, or technical issues.
              </p>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                While we implement reasonable security measures, we cannot guarantee complete protection against cyberattacks or absolute security of data transmission.
              </p>
            </div>

            {/* Section 12 */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>12. Compliance with Laws</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '16px' }}>
                This Website operates in compliance with Indian laws including:
              </p>
              <ul style={{ color: 'var(--text-secondary)', lineHeight: '1.8', paddingLeft: '24px' }}>
                <li>Information Technology Act, 2000 and IT Rules</li>
                <li>Digital Personal Data Protection Act, 2023</li>
                <li>Consumer Protection Act, 2019</li>
                <li>Copyright Act, 1957</li>
                <li>Trade Marks Act, 1999</li>
              </ul>
            </div>

            {/* Section 15 - Contact */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>15. Contact Information and Grievance Redressal</h2>
              <div style={{ 
                background: 'rgba(0, 255, 209, 0.05)', 
                border: '1px solid var(--brand-primary)', 
                padding: '24px' 
              }}>
                <h4 style={{ color: 'var(--text-primary)', marginBottom: '16px' }}>Grievance Officer</h4>
                <p className="body-medium" style={{ color: 'var(--text-secondary)', marginBottom: '8px' }}>
                  <Mail size={16} style={{ verticalAlign: 'middle', marginRight: '8px' }} />
                  Email: sandeep@vdmbi.org
                </p>
                <p className="body-medium" style={{ color: 'var(--text-secondary)', marginBottom: '8px' }}>
                  <Phone size={16} style={{ verticalAlign: 'middle', marginRight: '8px' }} />
                  Phone: +91 8050518788
                </p>
                <p className="body-medium" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                  <MapPin size={16} style={{ verticalAlign: 'middle', marginRight: '8px' }} />
                  Address: VDM Business Innovations, Bengaluru, Karnataka, India
                </p>
                <p className="body-small" style={{ color: 'var(--text-muted)' }}>
                  Response Time: Acknowledgment within 72 hours; resolution within 30 days
                </p>
              </div>
            </div>

            {/* Section 16 */}
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>16. Relationship to Other Policies</h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '16px' }}>
                This Disclaimer should be read in conjunction with:
              </p>
              <ul style={{ color: 'var(--text-secondary)', lineHeight: '1.8', paddingLeft: '24px' }}>
                <li><Link to="/privacy-policy" style={{ color: 'var(--brand-primary)' }}>Privacy Policy</Link></li>
                <li><Link to="/terms-of-service" style={{ color: 'var(--brand-primary)' }}>Terms of Service</Link></li>
                <li>Service-specific agreements and contracts</li>
              </ul>
            </div>

            {/* Acknowledgment */}
            <div style={{ 
              background: 'linear-gradient(135deg, rgba(0, 255, 209, 0.1) 0%, rgba(0, 255, 209, 0.02) 100%)', 
              border: '1px solid var(--brand-primary)', 
              padding: '30px',
              marginTop: '40px'
            }}>
              <h3 className="heading-3" style={{ marginBottom: '16px' }}>20. Acknowledgment and Acceptance</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                By accessing and using this Website, you acknowledge that you have read and understood this entire Disclaimer, accept all terms and limitations herein, agree to use Website information at your own risk, and will conduct independent verification and seek professional advice as needed.
              </p>
            </div>

            {/* Document Info */}
            <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid var(--border-subtle)' }}>
              <p className="body-small" style={{ color: 'var(--text-muted)' }}>
                Document Version: 1.0 | Policy Owner: VDM Business Innovations | Review Cycle: Annual | Next Review Date: February 2027
              </p>
              <p className="body-small" style={{ color: 'var(--text-muted)', marginTop: '8px' }}>
                Legal Compliance: Information Technology Act 2000, DPDP Act 2023, Consumer Protection Act 2019, Indian Contract Act 1872
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default WebsiteDisclaimer;
